// Library imports
import React from "react";
import ReactDOM from "react-dom/client";

// Application components
import App from "./App";

// Self-hosted IBM Plex (redesign handoff: no CDN, must work offline). Imported here — not
// as CSS @imports in index.css — so vite's asset pipeline emits and hashes the font files;
// the Tailwind v4 CSS pipeline inlines @imports without emitting their assets (404s on the
// deployed build). Weight 450 ("Text") isn't in the static builds; it falls back to 400.
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css";

// Styles
import "./index.css";

import { installStaleChunkRecovery } from "./lib/stale-chunk-recovery";

// Before render: a tab holding the previous deploy's index.html asks for chunk names that no longer
// exist, and every route in this app is lazy-loaded, so the failure shows up as a permanent
// "Loading…" rather than an error. One reload picks up the current index.html.
installStaleChunkRecovery();

// No permanent `.dark` on <html>: the appearance providers mirror the active theme classes
// (including `dark`) onto <body> via use-body-theme, so `dark:` variants only fire on
// actually-dark surfaces. Default (classless) surfaces still get dark tokens from :root.

// Get root element and validate its existence
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find root element");
}

// Cross-surface providers live in the root route (`__root.tsx`); auth/session and the
// dashboard sidebar are mounted per-surface so public marketing pages stay provider-light.
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
